import React from "react";
 
import { Helmet } from "react-helmet";
function About(){
return(
    <div>


<Helmet>
 
<title>Codeexampler About US</title>
<meta name="description" content="Codeexampler About US.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, python tutorial,c# tutorial for beginners in deeply knowledge " />
<link rel="canonical" href="https://www.codeexampler.com/about-us" />
</Helmet>





        <div className="ml-3">
    <h1 className="mt-4">About Us</h1>
<p className="mt-4 ml-2">  
CodeExampler is a Largest online learning platform, here you can learn about latest technology, programming languages, online exams preparations and more, Absolutely Free For Everyone.<br/><br/>

We publish Tutorials and articles related to Technology, Programming Languages.<br/><br/>

Our writers are highly experienced professionals in the markets of Technology, Programming Languages, Security.<br/><br/>

Our site is purely dedicated to those who are searching for Technology,Programming Languages Tutorials and all kinds of updates related to Web Technology.<br/><br/>

Our mission is to deliver high quality content to those who wish to stay connected with technology, programming languages and web technology to grow their knowledge day in and out.<br/><br/>

CodeExampler Website Created in India<br/><br/>


Join Facebook Page <a target="_blank" href="https://www.facebook.com/learncodingfreecodeexampler/">CodeExampler Facebook Page</a><br/><br/>
Join linkedin Page <a target="_blank" href="https://www.linkedin.com/company/codeexampler">CodeExampler Linkedin Page</a>
     



</p>



<h2 className="mt-4">We Provide's Tutorials</h2>


<p className="mt-4 ">We provide free tutorials on <a href="https://www.codeexampler.com/java-variables">Java variables Tutorial</a>, <a href="https://www.codeexampler.com/c-element">C Element</a>, <a href="https://www.codeexampler.com/python-variables">Python Variables</a>, <a href="https://www.codeexampler.com/csharp-first-program">Csharp(C#) First Program</a>, Difference between programming language,programming,computer study tutorials for free.</p>


<h2 className="mt-4">Leads4Needs is a Local Business Registration Website </h2>


<p className="mt-4 ">Search Local Business Online on <a href="https://www.leads4needs.com/">leads4needs</a> Promote Your Local Business Online with Free Leads Check all Types of Local Business on Leads4Needs Website </p>


    <h1 className="mt-5"> </h1>
    </div>
  
    </div>
)

}
export default About;